// Interfaces
import { IFormSelectOptionProps } from './interfaces';

// Antd
import { Select } from 'antd';

// i18n
import { useTranslation } from 'react-i18next';

// Lodash
import omit from 'lodash/omit';

import { observer } from 'mobx-react';

const { Option } = Select;

const FormSelectOption = observer((props: IFormSelectOptionProps) => {
  // Hook
  const { t } = useTranslation();

  return (
    <>
      <Select
        {...omit(props, ['onlyLabel', 'labelValue', 'disabledValues'])}
        placeholder={t(props?.placeholder || '')}
        className="select-option-common"
        loading={props?.loading}
        disabled={props?.disabled}
        onChange={event => {
          if (props?.onChange) props?.onChange(event);
        }}
        filterOption={(input: any, option: any) => option.props.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
        showSearch
        allowClear={props?.allowClear !== false}
      >
        {props?.list?.map(list => (
          <Option
            key={list.value}
            value={list.value}
            disabled={props?.disabledValues?.some(disabledValue => disabledValue?.label === list.value)}
          >
            {t(list.label)}
          </Option>
        ))}
      </Select>

      {props?.style?.display === 'none' ? <p className="font-14 text-grey font-weight-400">{props?.labelValue || '-'}</p> : <></>}
    </>
  );
});

export { FormSelectOption };
